import { render, staticRenderFns } from "./NewAccount.vue?vue&type=template&id=0611de85"
import script from "./NewAccount.vue?vue&type=script&lang=js"
export * from "./NewAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports